export default "__VITE_ASSET__DXWfakZf__"